import { Layout } from '@sunwebgroup/uds-ui/layout'
import Gallery from './Gallery'

export function HeroSection() {
  return (
    <Layout>
      <Gallery />
    </Layout>
  )
}
